import constants from "../../constants/Cars";

const setCars = (payload) => ({
	type: constants.setCars,
	payload,
});

export default setCars;
